// payslip design second one

// <div
//   id="payslip-print"
//   style={{
//     maxWidth: "600px",
//     margin: "auto",
//     padding: "20px",
//     border: "1px solid #ddd",
//     fontFamily: "Arial",
//     overflowX: "hidden", // ✅ prevents overflow
//   }}
// >
//   {/* Header */}
//   <div className="d-flex align-items-center justify-content-between mb-4">
//     {/* Left: Logo */}
//     <div>
//       <img
//         src="/assets/img/logo.png"
//         alt="Company Logo"
//         style={{ height: 30 }}
//       />
//     </div>

//     {/* Center: Company Name (Two Lines) */}
//     <div className="text-center flex-grow-1">
//       <h2 className="mb-0 fw-bold">ABC Technologies</h2>
//       <h4 className="mb-0">Private Limited</h4>
//     </div>

//     {/* Right: Email & Phone (Small Text) */}
//     <div className="text-end">
//       <h6 className="d-block fw-bold">Abdul@gmail.com</h6>
//       <h6 className="d-block fw-bold">+91 93466 96253</h6>
//     </div>
//   </div>

//   <hr />

//   {/* Employee Details */}
//   <div className="row mb-3">
//     <div className="col-md-4">
//       <p>
//         <strong> Name:</strong> Abdul Shaik
//       </p>
//       <p>
//         <strong> ID:</strong> EMP1023
//       </p>
//       <p>
//         <strong>Department:</strong> IT
//       </p>
//       <p>
//         <strong>Designation:</strong> Software Developer
//       </p>
//     </div>
//     <div className="col-md-4">
//       <p>
//         <strong>Total Days:</strong> 30.00
//       </p>
//       <p>
//         <strong>Days Payabule :</strong> 30.00
//       </p>
//       <p>
//         <strong>Leaves :</strong> 0
//       </p>
//       <p>
//         <strong>LOP :</strong> 0
//       </p>
//     </div>
//     <div className="col-md-4 text-end">
//       <p>
//         <strong>Pay Date:</strong> 30-Apr-2025
//       </p>
//       <p>
//         <strong>Bank:</strong> HDFC Bank
//       </p>
//       <p>
//         <strong>Account No:</strong> XXXX1234
//       </p>
//       <p>
//         <strong>DOJ:</strong> 22/09/2025
//       </p>
//     </div>
//   </div>

//   {/* Earnings & Deductions */}
//   <table
//     className="table table-bordered"
//     style={{ tableLayout: "fixed", width: "100%" }}
//   >
//     <thead>
//       <tr>
//         <th
//           className="sno-col"
//           style={{
//             backgroundColor: "#f3ad35ff",
//             color: "#fff",
//           }}
//         >
//           S.No
//         </th>

//         <th
//           style={{
//             backgroundColor: "#f3ad35ff",
//             color: "#fff",
//           }}
//         >
//           Earnings
//         </th>

//         <th
//           className="text-end amount-col"
//           style={{
//             backgroundColor: "#f3ad35ff",
//             color: "#fff",
//           }}
//         >
//           Amount (₹)
//         </th>

//         <th
//           className="sno-col"
//           style={{
//             backgroundColor: "#d90f0fff",
//             color: "#fff",
//           }}
//         >
//           S.No
//         </th>

//         <th
//           style={{
//             backgroundColor: "#d90f0fff",
//             color: "#fff",
//           }}
//         >
//           Deductions
//         </th>

//         <th
//           className="text-end amount-col"
//           style={{
//             backgroundColor: "#d90f0fff",
//             color: "#fff",
//           }}
//         >
//           Amount (₹)
//         </th>
//       </tr>
//     </thead>

//     <tbody>
//       <tr>
//         <td className="sno-col">1</td>
//         <td>Basic Salary</td>
//         <td className="text-end">30,000</td>

//         <td className="sno-col">1</td>
//         <td>PF</td>
//         <td className="text-end">1,800</td>
//       </tr>

//       <tr>
//         <td className="sno-col">2</td>
//         <td>HRA</td>
//         <td className="text-end">10,000</td>

//         <td className="sno-col">2</td>
//         <td>ESI</td>
//         <td className="text-end">500</td>
//       </tr>

//       <tr>
//         <td className="sno-col">3</td>
//         <td>Conveyance Allowance</td>
//         <td className="text-end">2,000</td>

//         <td className="sno-col">3</td>
//         <td>Tax</td>
//         <td className="text-end">2,700</td>
//       </tr>

//       <tr>
//         <td className="sno-col">4</td>
//         <td>Medical Allowance</td>
//         <td className="text-end">1,500</td>

//         <td className="sno-col">4</td>
//         <td>Advance Payment</td>
//         <td className="text-end">1,000</td>
//       </tr>

//       <tr>
//         <td className="sno-col">5</td>
//         <td>Special Allowance</td>
//         <td className="text-end">1,000</td>

//         <td className="sno-col"></td>
//         <td></td>
//         <td></td>
//       </tr>

//       <tr>
//         <td className="sno-col">6</td>
//         <td>Incentive</td>
//         <td className="text-end">2,500</td>

//         <td className="sno-col"></td>
//         <td></td>
//         <td></td>
//       </tr>

//       <tr>
//         <td className="sno-col">7</td>
//         <td>OT</td>
//         <td className="text-end">1,000</td>

//         <td className="sno-col"></td>
//         <td></td>
//         <td></td>
//       </tr>

//       {/* Totals */}
//       <tr className="fw-bold bg-light">
//         <td colSpan="2">Total Earnings</td>
//         <td className="text-end">51,000</td>

//         <td colSpan="2">Total Deductions</td>
//         <td className="text-end">7,000</td>
//       </tr>

//       {/* Net Salary */}
//       <tr className="fw-bold">
//         <td
//           colSpan="5"
//           className="text-end bg-success text-white"
//         >
//           Net Salary
//         </td>
//         <td className="text-end bg-success text-white">
//           44,000
//         </td>
//       </tr>
//     </tbody>
//   </table>

//   <div className="mt-3">
//     <p>
//       <strong>Net Salary (in words):</strong> Rupees Forty
//       Four Thousand Only
//     </p>
//   </div>

//   <hr />

//   <p className="text-center text-muted mb-1">
//     This is a system-generated payslip and does not require a
//     signature.
//   </p>

//   <p className="text-center text-muted fw-bold">
//     This payslip is generated by Perennial Code
//   </p>
// </div>

// <div
//   id="payslip-print-v2"
//   style={{
//     maxWidth: "600px",
//     margin: "auto",
//     padding: "20px",
//     border: "2px solid #333",
//     fontFamily: "Arial",
//     backgroundColor: "#fff",
//   }}
// >
//   {/* Header */}
//   <div
//     style={{
//       borderBottom: "2px solid #333",
//       paddingBottom: "10px",
//       marginBottom: "15px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "space-between",
//     }}
//   >
//     <img
//       src="/assets/img/logo.png"
//       alt="Logo"
//       style={{ height: 35 }}
//     />

//     <div className="text-center">
//       <h3 className="mb-0 fw-bold">ABC Technologies</h3>
//       <small>Private Limited</small>
//     </div>

//     <div className="text-end" style={{ fontSize: "12px" }}>
//       Abdul@gmail.com <br />
//       +91 93466 96253
//     </div>
//   </div>

//   {/* Payslip Title */}
//   <h5 className="text-center fw-bold mb-3">
//     PAY SLIP – APRIL 2025
//   </h5>

//   {/* Employee Info Table */}
//   <table className="table table-bordered mb-3">
//     <tbody>
//       <tr>
//         <td>
//           <strong>Name</strong>
//         </td>
//         <td>Abdul Shaik</td>
//         <td>
//           <strong>Employee ID</strong>
//         </td>
//         <td>EMP1023</td>
//       </tr>
//       <tr>
//         <td>
//           <strong>Department</strong>
//         </td>
//         <td>IT</td>
//         <td>
//           <strong>Designation</strong>
//         </td>
//         <td>Software Developer</td>
//       </tr>
//       <tr>
//         <td>
//           <strong>Bank</strong>
//         </td>
//         <td>HDFC Bank</td>
//         <td>
//           <strong>Account No</strong>
//         </td>
//         <td>XXXX1234</td>
//       </tr>
//       <tr>
//         <td>
//           <strong>Pay Date</strong>
//         </td>
//         <td>30-Apr-2025</td>
//         <td>
//           <strong>Date of Joining</strong>
//         </td>
//         <td>22/09/2025</td>
//       </tr>
//     </tbody>
//   </table>

//   {/* Attendance */}
//   <table className="table table-bordered mb-3">
//     <thead>
//       <tr style={{ backgroundColor: "#f1f1f1" }}>
//         <th>Total Days</th>
//         <th>Payable Days</th>
//         <th>Leaves</th>
//         <th>LOP</th>
//       </tr>
//     </thead>
//     <tbody>
//       <tr className="text-center">
//         <td>30</td>
//         <td>30</td>
//         <td>0</td>
//         <td>0</td>
//       </tr>
//     </tbody>
//   </table>

//   {/* Earnings */}
//   <h6
//     style={{
//       backgroundColor: "#f3ad35ff",
//       color: "#fff",
//       padding: "6px",
//     }}
//   >
//     Earnings
//   </h6>

//   <table className="table table-bordered mb-3">
//     <tbody>
//       <tr>
//         <td>Basic Salary</td>
//         <td className="text-end">30,000</td>
//       </tr>
//       <tr>
//         <td>HRA</td>
//         <td className="text-end">10,000</td>
//       </tr>
//       <tr>
//         <td>Conveyance Allowance</td>
//         <td className="text-end">2,000</td>
//       </tr>
//       <tr>
//         <td>Medical Allowance</td>
//         <td className="text-end">1,500</td>
//       </tr>
//       <tr>
//         <td>Special Allowance</td>
//         <td className="text-end">1,000</td>
//       </tr>
//       <tr>
//         <td>Incentive</td>
//         <td className="text-end">2,500</td>
//       </tr>
//       <tr>
//         <td>OT</td>
//         <td className="text-end">1,000</td>
//       </tr>
//       <tr className="fw-bold bg-light">
//         <td>Total Earnings</td>
//         <td className="text-end">51,000</td>
//       </tr>
//     </tbody>
//   </table>

//   {/* Deductions */}
//   <h6
//     style={{
//       backgroundColor: "#d90f0fff",
//       color: "#fff",
//       padding: "6px",
//     }}
//   >
//     Deductions
//   </h6>

//   <table className="table table-bordered mb-3">
//     <tbody>
//       <tr>
//         <td>PF</td>
//         <td className="text-end">1,800</td>
//       </tr>
//       <tr>
//         <td>ESI</td>
//         <td className="text-end">500</td>
//       </tr>
//       <tr>
//         <td>Tax</td>
//         <td className="text-end">2,700</td>
//       </tr>
//       <tr>
//         <td>Advance Payment</td>
//         <td className="text-end">1,000</td>
//       </tr>
//       <tr className="fw-bold bg-light">
//         <td>Total Deductions</td>
//         <td className="text-end">7,000</td>
//       </tr>
//     </tbody>
//   </table>

//   {/* Net Salary */}
//   <div
//     style={{
//       backgroundColor: "#28a745",
//       color: "#fff",
//       padding: "10px",
//       textAlign: "right",
//       fontWeight: "bold",
//     }}
//   >
//     Net Salary : ₹ 44,000
//   </div>

//   <p className="mt-2">
//     <strong>Net Salary (in words):</strong> Rupees Forty Four
//     Thousand Only
//   </p>

//   <hr />

//   {/* Footer */}
//   <p className="text-center text-muted mb-1">
//     This is a system-generated payslip and does not require a
//     signature.
//   </p>
//   <p className="text-center text-muted fw-bold">
//     This payslip is generated by Perennial Code
//   </p>
// </div>



// import React, { useState } from "react";
// import { Link } from "react-router-dom/dist";
// // import Table from "../../../../../core/pagination/datatable";
// import CommonFooter from "../../../../core/common/footer/commonFooter";
// // import { Select } from "antd";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import { RotateCcw } from "feather-icons-react/build/IconComponents";
// import { faPrint } from "@fortawesome/free-solid-svg-icons";
// import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
// // import Swal from "sweetalert2";

// const PaySlip = () => {
//   const [dataLoading, setDataLoading] = useState(false);
//   console.log(dataLoading);
//   console.log(setDataLoading);
//   //   const navigate = useNavigate();

//   // Static JSON data as requested
//   const salaryData = [
//     {
//       key: 1,
//       employeeid: 1001,
//       employee: "Ravi Kumar",
//       Designation: "HR Executive",
//       Grosssalary: 45000,
//       WorkDays: 26,
//       pdays: 24,
//       basic: 20000,
//       hra: 10000,
//       Conveyance: 2000,
//       lessmedicalallowance: 1500,
//     },
//     {
//       key: 2,
//       employeeid: 1002,
//       employee: "Anjali Sharma",
//       Designation: "Accountant",
//       Grosssalary: 50000,
//       WorkDays: 26,
//       pdays: 22,
//       basic: 22000,
//       hra: 12000,
//       Conveyance: 2500,
//       lessmedicalallowance: 1800,
//     },
//     {
//       key: 3,
//       employeeid: 1003,
//       employee: "Suresh Reddy",
//       Designation: "Software Engineer",
//       Grosssalary: 65000,
//       WorkDays: 26,
//       pdays: 26,
//       basic: 30000,
//       hra: 15000,
//       Conveyance: 3000,
//       lessmedicalallowance: 2000,
//     },
//     {
//       key: 4,
//       employeeid: 1004,
//       employee: "Neha Verma",
//       Designation: "Operations Manager",
//       Grosssalary: 70000,
//       WorkDays: 26,
//       pdays: 23,
//       basic: 32000,
//       hra: 16000,
//       Conveyance: 3500,
//       lessmedicalallowance: 2200,
//     },
//     {
//       key: 5,
//       employeeid: 1005,
//       employee: "Amit Patel",
//       Designation: "Sales Executive",
//       Grosssalary: 48000,
//       WorkDays: 26,
//       pdays: 25,
//       basic: 21000,
//       hra: 11000,
//       Conveyance: 2500,
//       lessmedicalallowance: 1700,
//     },
//   ];

//   const [data] = useState(salaryData);

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleReload = () => {
//     window.location.reload();
//   };

//   const generatePDF = () => {
//     if (data.length === 0) return;

//     const doc = new jsPDF();
//     doc.text("Employee Annual CTC Report", 14, 10);

//     const tableColumn = [
//       "S.No",
//       "Employee",
//       "Emp Code",
//       "Monthly Salary",
//       "Yearly CTC",
//       "Group",
//       "Start Date",
//       "End Date",
//     ];
//     const tableRows = data.map((item, index) => [
//       index + 1,
//       item.employee,
//       item.empCode,
//       `$${item.monthlySalary.toLocaleString()}`,
//       `$${item.yearlyCTC.toLocaleString()}`,
//       `$${item.group.toLocaleString()}`,
//       formatDate(item.startDate),
//       formatDate(item.endDate),
//     ]);

//     doc.autoTable({ head: [tableColumn], body: tableRows, startY: 20 });
//     doc.save("Employee_Annual_CTC.pdf");
//   };

//   const renderTooltip = (props) => (
//     <Tooltip id="pdf-tooltip" {...props}>
//       PDF
//     </Tooltip>
//   );

//   const renderRefreshTooltip = (props) => (
//     <Tooltip id="refresh-tooltip" {...props}>
//       Refresh
//     </Tooltip>
//   );

//   const handlePrintPayslip = () => {
//     setShowPayslip(true);
//   };

//   const [showPayslip, setShowPayslip] = useState(false);

//   return (
//     <>
//       <style>
//         {`
//        .sno-col {
//   width: 35px;
//   text-align: center;
//   font-size: 12px;
// }

// .amount-col {
//   width: 90px;
//   font-size: 12px;
// }

// .table td,
// .table th {
//   padding: 6px;
//   font-size: 13px;
//   word-wrap: break-word;
// }
//   .attendance-head th {
//   background-color: #bcedf8ff !important;
//   color: #fff;
// }
//   .payslip-card-body {

//   margin: 0;     
//   padding-top:2;        


// }
//   .payslip-container {
//   max-width: 600px;
//   margin: 0 auto;         /* center horizontally */
//   padding: 12px;
//   border: 1px solid #333;
//   font-family: Arial, sans-serif;
//   font-size: 13px;
//   line-height: 1.2;
//   background-color: #fff;
// }

//       `}
//       </style>

//       <div>
//         <div className="page-wrapper">
//           <div className="content">
//             <div className="page-header m-2">
//               <div className="add-item d-flex">
//                 <div className="page-title">
//                   <nav aria-label="breadcrumb">
//                     <ol className="breadcrumb">
//                       <li className="breadcrumb-item">
//                         <Link to="/rollcall/dashboard">
//                           <i className="fas fa-home fa-lg" />
//                         </Link>
//                       </li>
//                       <h4 className="breadcrumb-item " aria-current="page">
//                         Pay Slips
//                       </h4>
//                     </ol>
//                   </nav>
//                   <h6>Manage your Pay Slip here</h6>
//                 </div>
//               </div>
//               <ul className="table-top-head">
//                 <li>
//                   <OverlayTrigger placement="top" overlay={renderTooltip}>
//                     <Link onClick={generatePDF}>
//                       <ImageWithBasePath
//                         src="assets/img/icons/pdf.svg"
//                         alt="PDF"
//                       />
//                     </Link>
//                   </OverlayTrigger>
//                 </li>
//                 <li onClick={handleReload}>
//                   <OverlayTrigger
//                     placement="top"
//                     overlay={renderRefreshTooltip}
//                   >
//                     <Link>
//                       <RotateCcw />
//                     </Link>
//                   </OverlayTrigger>
//                 </li>
//               </ul>
//             </div>
//             <div className="row align-items-stretch">
//               <div className=" col-md-4">
//                 <div className="card p-4">
//                   <div className="row align-items-center g-3">
//                     <div className="col-md-12">
//                       <label className="form-label">Branch</label>
//                       <select className="form-select">
//                         <option selected>Sindh</option>
//                         <option>Punjab</option>
//                       </select>
//                     </div>
//                     <div className="col-md-12">
//                       <label className="form-label">Department</label>
//                       <select className="form-select">
//                         <option selected>Select Department</option>
//                         <option>HR</option>
//                         <option>Finance</option>
//                       </select>
//                     </div>
//                     {/* Employee Dropdown */}
//                     <div className="col-md-12">
//                       <label className="form-label">Employee</label>
//                       <select className="form-select">
//                         <option selected>Select Employee</option>
//                         <option>John Doe</option>
//                         <option>Jane Smith</option>
//                       </select>
//                     </div>

//                     {/* Effective Pay Period Dropdown */}
//                     <div className="col-md-12">
//                       <label className="form-label"> Pay Period</label>
//                       <select className="form-select">
//                         <option selected>February-2025</option>
//                         <option>March-2025</option>
//                       </select>
//                     </div>

//                     {/* Active Pay Button */}
//                     <div className="col-md-12 d-flex align-items-center justify-content-right">
//                       <button
//                         className="btn btn-primary"
//                         // style={{ marginBottom: "" }}
//                         onClick={handlePrintPayslip}
//                       >
//                         <FontAwesomeIcon icon={faPrint} title="Print Payslip" />
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="card table-list-card col-md-8 pb-5 pt-1 px-5 extra-pb">
//                 <div
//                   className="card-body payslip-card-body"

//                 >
//                   {!showPayslip && (
//                     <div className="text-center text-muted">
//                       <p>Select filters and click Print to view payslip</p>
//                     </div>
//                   )}

//                   {showPayslip && (

//                       <div  className="payslip-container"
//                         id="payslip-print-compact"
//                       >
//                         {/* Header */}
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             borderBottom: "1px solid #333",
//                             paddingBottom: "6px",
//                           }}
//                           className="mb-1"
//                         >
//                           <img
//                             src="/assets/img/logo.png"
//                             alt="Logo"
//                             style={{ height: 30 }}
//                           />

//                           <div style={{ flex: 1, textAlign: "center" }}>
//                             <h1>ABC Technologies Pvt Ltd</h1>
//                           </div>
//                         </div>

//                         {/* Employee Info (Compact Rows) */}
//                         <table className="table table-bordered mb-1">
//                           <tbody>
//                             <tr>
//                               <td>
//                                 <strong>Name</strong>
//                               </td>
//                               <td>Abdul Shaik</td>
//                               <td>
//                                 <strong>Employee ID</strong>
//                               </td>
//                               <td>EMP1023</td>
//                             </tr>
//                             <tr>
//                               <td>
//                                 <strong>Department</strong>
//                               </td>
//                               <td>IT</td>
//                               <td>
//                                 <strong>Designation</strong>
//                               </td>
//                               <td>Software Developer</td>
//                             </tr>
//                             <tr>
//                               <td>
//                                 <strong>No Of Days</strong>
//                               </td>
//                               <td>30</td>
//                               <td>
//                                 <strong>Pan No</strong>
//                               </td>
//                               <td>XXXX1234</td>
//                             </tr>
//                             <tr>
//                               <td>
//                                 <strong>Pay Date</strong>
//                               </td>
//                               <td>30-Apr-2025</td>
//                               <td>
//                                 <strong>Date of Joining</strong>
//                               </td>
//                               <td>22/09/2025</td>
//                             </tr>
//                           </tbody>
//                         </table>

//                         {/* Earnings & Deductions */}
//                         <table
//                           className="table table-bordered mt-2"
//                           style={{
//                             width: "100%",
//                             tableLayout: "fixed",
//                             fontSize: "12px",
//                           }}
//                         >
//                           <thead>
//                             <tr>
//                               <th
//                                 style={{
//                                   background: "#fae676ff",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 Earnings
//                               </th>
//                               <th
//                                 className="text-end"
//                                 style={{
//                                   background: "#fae676ff",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 ₹ Amount
//                               </th>
//                               <th
//                                 style={{
//                                   background: "#d90f0fff",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 Deductions
//                               </th>
//                               <th
//                                 className="text-end"
//                                 style={{
//                                   background: "#d90f0fff",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 ₹ Amount
//                               </th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             <tr>
//                               <td>Basic</td>
//                               <td className="text-end">30,000</td>
//                               <td>PF</td>
//                               <td className="text-end">1,800</td>
//                             </tr>
//                             <tr>
//                               <td>HRA</td>
//                               <td className="text-end">10,000</td>
//                               <td>ESI</td>
//                               <td className="text-end">500</td>
//                             </tr>
//                             <tr>
//                               <td>Conveyance</td>
//                               <td className="text-end">2,000</td>
//                               <td>Tax</td>
//                               <td className="text-end">2,700</td>
//                             </tr>
//                             <tr>
//                               <td>Medical</td>
//                               <td className="text-end">1,500</td>
//                               <td>Advance</td>
//                               <td className="text-end">1,000</td>
//                             </tr>
//                             <tr>
//                               <td>Special</td>
//                               <td className="text-end">1,000</td>
//                               <td></td>
//                               <td></td>
//                             </tr>
//                             <tr>
//                               <td>Incentive</td>
//                               <td className="text-end">2,500</td>
//                               <td></td>
//                               <td></td>
//                             </tr>
//                             <tr>
//                               <td>OT</td>
//                               <td className="text-end">1,000</td>
//                               <td></td>
//                               <td></td>
//                             </tr>

//                             <tr className="fw-bold bg-light">
//                               <td>Total</td>
//                               <td className="text-end">51,000</td>
//                               <td>Total</td>
//                               <td className="text-end">7,000</td>
//                             </tr>

//                             <tr className="fw-bold">
//                               <td
//                                 colSpan="3"
//                                 className="text-end bg-success text-white"
//                               >
//                                 Net Salary
//                               </td>
//                               <td className="text-end bg-success text-white">
//                                 44,000
//                               </td>
//                             </tr>
//                           </tbody>
//                         </table>

//                         {/* Amount in Words */}
//                         <div style={{ fontSize: "12px", marginTop: "4px" }}>
//                           <strong>In Words:</strong> Rupees Forty Four Thousand
//                           Only
//                         </div>

//                         {/* Footer */}
//                         <div
//                           style={{
//                             fontSize: "10px",
//                             textAlign: "center",
//                             marginTop: "6px",
//                           }}
//                         >
//                           System generated payslip | Generated by{" "}
//                           <strong>Perennial Code</strong>
//                         </div>
//                       </div>

//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//           <CommonFooter />
//         </div>
//       </div>
//     </>
//   );
// };

// export default PaySlip;






import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom/dist";
// import Table from "../../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
// import { Select } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { Spin } from "antd";
import { Filter, Search } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import Swal from "sweetalert2";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";


const PaySlip = () => {
  const [showPayslip, setShowPayslip] = useState(false);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [branchesList, setBranchesList] = useState([]);
  const [DeptList, setDeptList] = useState([]);
  const [tableFilteredEmployees, setTableFilteredEmployees] = useState([]);
  const [PayPeriodlist, setPayPeriodlist] = useState([]);

  const [tableBranchId, setTableBranchId] = useState(0);
  const [tableDeptId, setTableDeptId] = useState(0);
  const [tableEmpId, setTableEmpId] = useState(0);


  const [selectedPayPeriod, setSelectedPayPeriod] = useState(null);
  const [payslipData, setPayslipData] = useState(null);
  console.log(payslipData);
  const [loadingPayslip, setLoadingPayslip] = useState(false);
  const navigate = useNavigate();

  const payslipRef = useRef(null);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleReload = () => {
    window.location.reload();
  };




  const generatePDF = () => {
    if (!payslipData) {
      Swal.fire({
        icon: "warning",
        title: "No Payslip",
        text: "Please generate the payslip before downloading the PDF",
        confirmButtonColor: "#3085d6",
      });
      return;
    }
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();

    const borderX = 10;
    const borderY = 10;
    const borderWidth = 190;

    const logo = "/assets/img/logo.png";
    doc.addImage(logo, "PNG", 25, 20, 30, 12);

    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(payslipData.OrgName, pageWidth / 2, 26, { align: "center" });

    doc.setLineWidth(0.5);
    doc.line(20, 32, pageWidth - 20, 32);

    doc.autoTable({
      startY: 35,
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 3 },
      columnStyles: {
        0: { fontStyle: "bold", cellWidth: 35 },
        1: { cellWidth: 55 },
        2: { fontStyle: "bold", cellWidth: 35 },
        3: { cellWidth: 55 },
      },
      body: [
        ["Name", payslipData.UserName, "Employee ID", payslipData.BadgeId],
        ["Department", payslipData.Department, "Designation", payslipData.Designation],
        ["No of Days", payslipData.WorkingDays, "PAN No", payslipData.PAN || "N/A"],
        ["Pay Date", formatDate(payslipData.PayPeriodName), "Date of Joining", formatDate(payslipData.DateOfJoining)],
      ],
    });

    const earnings = payslipData.Earnings || [];
    const deductions = payslipData.Deductions || [];
    const rows = Math.max(earnings.length, deductions.length);

    const body = [];
    for (let i = 0; i < rows; i++) {
      body.push([
        earnings[i]?.SalaryHead || "",
        earnings[i] ? earnings[i].Amount.toFixed(2) : "",
        deductions[i]?.SalaryHead || "",
        deductions[i] ? deductions[i].Amount.toFixed(2) : "",
      ]);
    }

    body.push([
      "Total",
      payslipData.EarningsTotal.toFixed(2),
      "Total",
      payslipData.DeductionsTotal.toFixed(2),
    ]);

    body.push([
      "Net Salary",
      "",
      "",
      payslipData.NetSalary.toFixed(2),
    ]);

    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 5,
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: { textColor: [255, 255, 255] },
      head: [[
        { content: "Earnings", styles: { fillColor: [250, 230, 118], textColor: [0, 0, 0] } },
        { content: "Amount", styles: { fillColor: [250, 230, 118], textColor: [0, 0, 0], halign: "right" } },
        { content: "Deductions", styles: { fillColor: [217, 15, 15] } },
        { content: "Amount", styles: { fillColor: [217, 15, 15], halign: "right" } },
      ]],
      columnStyles: {
        0: { cellWidth: 60 },
        1: { cellWidth: 30, halign: "right" },
        2: { cellWidth: 60 },
        3: { cellWidth: 30, halign: "right" },
      },
      body,
      didParseCell: function (data) {
        if (data.row.index === body.length - 2) {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [240, 240, 240];
        }
        if (data.row.index === body.length - 1) {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [0, 128, 0];
          data.cell.styles.textColor = [255, 255, 255];
        }
      },
    });

    const finalY = doc.lastAutoTable.finalY + 8;

    doc.setFontSize(8);
    doc.text(
      "System generated payslip | Generated by Perennial Code",
      pageWidth / 2,
      finalY,
      { align: "center" }
    );

    doc.setDrawColor(0);
    doc.setLineWidth(0.8);
    doc.roundedRect(
      borderX,
      borderY,
      borderWidth,
      finalY - borderY + 6, // 👈 dynamic height
      6,
      6
    );

    doc.save(`Payslip_${payslipData.BadgeId}.pdf`);
  };


  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      PDF
    </Tooltip>
  );

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const BranchesOptions = [
    { label: "All Branches", value: 0 },
    ...branchesList.map((branch) => ({
      label: branch.Name,
      value: branch.branchid,
    })),
  ];
  const DeptOptions = [
    { label: "All Dept", value: 0 },
    ...DeptList.map((Dept) => ({
      label: Dept.Name,
      value: Dept.DepartmentId,
    })),
  ];
  const PayperiodOptions = [
    { label: "All PayPeriods", value: 0 },
    ...(PayPeriodlist?.map((period) => ({
      label: period.Name,
      value: period.Id,
    })) || []),
  ];
  const employeeOptions = [
    { label: "Select Employee", value: 0 },
    ...tableFilteredEmployees.map(emp => ({
      label: emp.UserWithBadge,
      value: emp.RegId,
    }))
  ];



  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    // const superId = sessionStorage.getItem("superId");
    const superId = sessionStorage.getItem("PayrollSuperId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchBranchsList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Branches");
          }

          const data = await response.json();

          if (data.status) {
            setBranchesList(data.ResultData);
          } else {
            console.error("Invalid Branches response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching BranchesList:", error.message);
        }
      };
      fetchBranchsList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchDeptList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Dept");
          }

          const data = await response.json();

          if (data.status) {
            setDeptList(data.ResultData);
          } else {
            console.error("Invalid Dept response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching DeptList:", error.message);
        }
      };
      fetchDeptList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchPayperiodList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}payroll/payroll/getPayPeriods?SuperId=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch PayPeriods");
          }

          const data = await response.json();

          if (data.status) {
            setPayPeriodlist(data.ResultData);
          } else {
            console.error("Invalid PayPeriod response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching PayPeriodList:", error.message);
        }
      };
      fetchPayperiodList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (!superIdData) return;

    const fetchTableEmployees = async () => {
      try {

        const branchId = tableBranchId || 0;
        const deptId = tableDeptId || 0;

        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/payroll/getemployees?superid=${superIdData}&BranchId=${branchId}&DeptId=${deptId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
          }
        );

        const data = await response.json();
        setTableFilteredEmployees(data.status ? data.ResultData : []);

      } catch (error) {
        console.error("Employee fetch error:", error);
        setTableFilteredEmployees([]);
      }
    };

    fetchTableEmployees();

  }, [superIdData, tableBranchId, tableDeptId]);

  const fetchPayslip = async () => {

    if (!selectedPayPeriod || !tableEmpId) {
      Swal.fire({
        icon: "warning",
        title: "Missing Selection",
        text: "Please select both Employee and Pay Period",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    try {
      setLoadingPayslip(true);

      const response = await fetch(
        `${Payroll_API_BASE_URL}payroll/payslips/getpayslips?SuperId=${superIdData}&PayperiodId=${selectedPayPeriod.value}&RegId=${tableEmpId}&BranchId=${tableBranchId}&DeptId=${tableDeptId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
        }
      );

      const data = await response.json();

      if (data.status && data.ResultData.length > 0) {
        setPayslipData(data.ResultData[0]);
        setShowPayslip(true);
      } else {
        Swal.fire({
          icon: "info",
          title: "No Payslip",
          text: "No payslip found for the selected employee and pay period",
          confirmButtonColor: "#3085d6",
        });
        setPayslipData(null);
      }
    } catch (error) {
      console.error("Payslip fetch error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch payslip. Please try again later.",
        confirmButtonColor: "#d33",
      });

    } finally {
      setLoadingPayslip(false);
    }
  };

  const earnings = payslipData?.Earnings || [];
  const deductions = payslipData?.Deductions || [];

  const maxRows = Math.max(earnings.length, deductions.length);

  const combinedRows = Array.from({ length: maxRows }, (_, i) => ({
    earning: earnings[i] || null,
    deduction: deductions[i] || null,
  }));

  return (
    <>
      <style>
        {`
       .sno-col {
  width: 35px;
  text-align: center;
  font-size: 12px;
}

.amount-col {
  width: 90px;
  font-size: 12px;
}

.table td,
.table th {
  padding: 6px;
  font-size: 13px;
  word-wrap: break-word;
}
  .attendance-head th {
  background-color: #bcedf8ff !important;
  color: #fff;
}
  .payslip-card-body {
          
  margin: 0;     
  padding-top:2;        
       
  
}
  .payslip-container {
  max-width: 600px;
  margin: 0 auto;         /* center horizontally */
  padding: 12px;
  border: 1px solid #333;
  font-family: Arial, sans-serif;
  font-size: 13px;
  line-height: 1.2;
  background-color: #fff;
}

      `}
      </style>

      <div>
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header m-2">
              <div className="add-item d-flex">
                <div className="page-title">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/rollcall/dashboard">
                          <i className="fas fa-home fa-lg" />
                        </Link>
                      </li>
                      <h4 className="breadcrumb-item " aria-current="page">
                        Pay Slips
                      </h4>
                    </ol>
                  </nav>
                  <h6>Manage your Pay Slip here</h6>
                </div>
              </div>
              <ul className="table-top-head">
                <li>
                  <OverlayTrigger placement="top" overlay={renderTooltip}>
                    <Link onClick={generatePDF}>
                      <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="PDF" />
                    </Link>
                  </OverlayTrigger>
                </li>
                <li onClick={handleReload}>
                  <OverlayTrigger
                    placement="top"
                    overlay={renderRefreshTooltip}
                  >
                    <Link>
                      <RotateCcw />
                    </Link>
                  </OverlayTrigger>
                </li>
              </ul>
            </div>
            <div className="row align-items-stretch">
              <div className="col-md-4">
                <div className="card p-4">
                  <div className="row g-3">

                    {/* Advanced Filters */}
                    {showAdvancedSearch && (
                      <>
                        <div className="col-12">
                          <label className="form-label">Branch</label>
                          <Select
                            isClearable
                            isSearchable
                            placeholder="Select Branch"
                            classNamePrefix="react-select"
                            options={BranchesOptions}
                            value={BranchesOptions.find(opt => opt.value === tableBranchId)}
                            onChange={(selected) => setTableBranchId(selected?.value || 0)}
                            style={{ width: "100%" }}
                            optionFilterProp="label"
                          />
                        </div>

                        <div className="col-12">
                          <label className="form-label">Department</label>
                          <Select
                            isClearable
                            isSearchable
                            classNamePrefix="react-select"
                            placeholder="Select Dept"
                            options={DeptOptions}
                            value={DeptOptions.find(opt => opt.value === tableDeptId)}
                            onChange={(selected) => setTableDeptId(selected?.value || 0)}
                            style={{ width: "100%" }}
                            optionFilterProp="label"
                          />
                        </div>
                      </>
                    )}

                    {/* Employee – always visible */}
                    <div className="col-12">
                      <label className="form-label">Employee</label>
                      <Select
                        isClearable
                        isSearchable
                        classNamePrefix="react-select"
                        placeholder="Select Employee"
                        options={employeeOptions}
                        value={employeeOptions.find(opt => opt.value === tableEmpId)}
                        onChange={(selected) => setTableEmpId(selected?.value || 0)}
                        style={{ width: "100%" }}
                        optionFilterProp="label"
                        virtual={false}
                      />
                    </div>

                    {/* Pay Period */}
                    <div className="col-12">
                      <label className="form-label">Pay Period</label>
                      <Select
                        isClearable
                        isSearchable
                        classNamePrefix="react-select"
                        labelInValue
                        placeholder="Select PayPeriod"
                        options={PayperiodOptions}
                        value={selectedPayPeriod}
                        onChange={(selected) => setSelectedPayPeriod(selected)}
                        style={{ width: "100%" }}
                      />
                    </div>

                    {/* Actions */}
                    <div className="col-12 d-flex justify-content-between align-items-center mt-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => {
                          setShowAdvancedSearch((prev) => !prev);
                          setTableBranchId(0);
                          setTableDeptId(0);
                          setTableEmpId(0);
                          setSelectedPayPeriod(0);
                        }}
                        title={showAdvancedSearch ? "Close Advanced Search" : "Open Advanced Search"}
                        style={{ width: 38, height: 38 }}
                      >
                        {showAdvancedSearch ? (
                          <Search size={20} />
                        ) : (
                          <Filter size={20} />
                        )}
                      </button>

                      <button
                        className="btn btn-primary"
                        onClick={fetchPayslip}
                      >
                        <FontAwesomeIcon icon={faPrint} /> Print
                      </button>
                    </div>

                  </div>
                </div>
              </div>

              <div className="card table-list-card col-md-8 pb-5 pt-1 px-5 extra-pb">
                {loadingPayslip && (
                  <div
                    className="position-absolute top-50 start-50 translate-middle"
                    style={{ zIndex: 10 }}
                  >
                    <Spin size="large" tip="Loading Payslip..." />
                  </div>
                )}
                <div
                  className="card-body payslip-card-body"
                >
                  {!showPayslip && (
                    <div className="d-flex justify-content-center mt-5 text-muted">
                      <p>Select filters and click Print to view payslip</p>
                    </div>
                  )}
                  {showPayslip && !loadingPayslip && (
                    <div ref={payslipRef} className="payslip-container" id="payslip-print-compact">
                      {/* Header */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderBottom: "1px solid #333",
                          paddingBottom: "6px",
                        }}
                        className="mb-1"
                      >
                        <img
                          src="/assets/img/logo.png"
                          alt="Logo"
                          style={{ height: 30 }}
                        />

                        <div style={{ flex: 1, textAlign: "center" }}>
                          <h1>{payslipData?.OrgName}</h1>
                        </div>
                      </div>

                      {/* Employee Info (Compact Rows) */}
                      <table className="table table-bordered mb-1">
                        <tbody>
                          <tr>
                            <td>
                              <strong>Name</strong>
                            </td>
                            <td>{payslipData?.UserName}</td>
                            <td>
                              <strong>Employee ID</strong>
                            </td>
                            <td>{payslipData?.BadgeId}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Department</strong>
                            </td>
                            <td>{payslipData?.Department}</td>
                            <td>
                              <strong>Designation</strong>
                            </td>
                            <td>{payslipData?.Designation}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>No Of Days</strong>
                            </td>
                            <td>{payslipData?.WorkingDays}</td>
                            <td>
                              <strong>Pan No</strong>
                            </td>
                            <td>{payslipData?.PAN || "N/A"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Pay Date</strong>
                            </td>
                            <td>{formatDate(payslipData?.PayPeriodName)}</td>
                            <td>
                              <strong>Date of Joining</strong>
                            </td>
                            <td>{formatDate(payslipData?.DateOfJoining)}</td>
                          </tr>
                        </tbody>
                      </table>

                      {/* Earnings & Deductions */}
                      <table
                        className="table table-bordered mt-2"
                        style={{
                          width: "100%",
                          tableLayout: "fixed",
                          fontSize: "12px",
                        }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                background: "#fae676ff",
                                color: "#fff",
                              }}
                            >
                              Earnings
                            </th>
                            <th
                              className="text-end"
                              style={{
                                background: "#fae676ff",
                                color: "#fff",
                              }}
                            >
                              ₹ Amount
                            </th>
                            <th
                              style={{
                                background: "#d90f0fff",
                                color: "#fff",
                              }}
                            >
                              Deductions
                            </th>
                            <th
                              className="text-end"
                              style={{
                                background: "#d90f0fff",
                                color: "#fff",
                              }}
                            >
                              ₹ Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {combinedRows.map((row, index) => (
                            <tr key={index}>
                              {/* Earnings */}
                              <td>{row.earning?.SalaryHead || ""}</td>
                              <td className="text-end">
                                {row.earning ? row.earning.Amount.toFixed(2) : ""}
                              </td>

                              {/* Deductions */}
                              <td>{row.deduction?.SalaryHead || ""}</td>
                              <td className="text-end">
                                {row.deduction ? row.deduction.Amount.toFixed(2) : ""}
                              </td>
                            </tr>
                          ))}

                          <tr className="fw-bold bg-light">
                            <td>Total</td>
                            <td className="text-end">{payslipData?.EarningsTotal.toFixed(2)}</td>
                            <td>Total</td>
                            <td className="text-end">{payslipData?.DeductionsTotal.toFixed(2)}</td>
                          </tr>

                          <tr className="fw-bold">
                            <td colSpan="3" className="text-end bg-success text-white">
                              Net Salary
                            </td>
                            <td className="text-end bg-success text-white">
                              {payslipData?.NetSalary.toFixed(2)}
                            </td>
                          </tr>

                        </tbody>
                      </table>

                      {/* Amount in Words */}
                      {/* <div style={{ fontSize: "12px", marginTop: "4px" }}>
                        <strong>In Words:</strong> Rupees Forty Four Thousand
                        Only
                      </div> */}

                      {/* Footer */}
                      <div
                        style={{
                          fontSize: "10px",
                          textAlign: "center",
                          marginTop: "6px",
                        }}
                      >
                        System generated payslip | Generated by{" "}
                        <strong>Perennial Code</strong>
                      </div>
                    </div>

                  )}
                </div>
              </div>
            </div>
          </div>
          <CommonFooter />
        </div>
      </div>
    </>
  );
};

export default PaySlip;


